import { useEffect, useState } from "react";
import DataTable from "../../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const integrationDeleteEndpoint = ApiEndpoints.tmsIntegration.integrationDelete;
const integrationListEndpoint = ApiEndpoints.tmsIntegration.integrationList;
const integrationEditPath = "edit-tms-integration";
const tableHeader = ["Date", "Category", "Name", "Slug", "Logo"];
const tbody = ["createdAt", "category_name", "name", "slug", "logo"];

export default function TmsIntegrationListing() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", integrationListEndpoint);
      setData(response?.integrations || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (integration_id) => {
    try {
      const response = await ApiRequest("POST", integrationDeleteEndpoint, { integration_id });
      response.error ? toast.error(response.message) : toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: "TMS Integration",
    user: "Admin",
    innerpage: "TMS Integration / Integrations"
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-tms-integration">Add +</Link>
        <DataTable data={data} tableHeader={tableHeader} tbody={tbody} editPath={integrationEditPath} onDelete={handleDelete} />
      </div>
    </>
  );
}
